export default __webpack_public_path__ + "static/media/loader.627e49e7.gif";